import { css, type Theme } from "@emotion/react";

export const panel = css`
  position: relative;
  height: 100%;
`;

export const viewport = css`
  height: 100%;
  overflow: hidden;
`;

/* A vertical embla carousel needs a column flex track where every slide
   matches the viewport height, otherwise snap points drift. */
export const slideColumn = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const slideItem = css`
  display: flex;
  flex: 0 0 100%;
  min-height: 0;

  > * {
    flex: 1;
  }
`;

export const navOverlay = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  right: ${theme.ds5.spacing.gap.large};
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
`;

/* Clears the floating dot navigation: its gap.large right offset plus the 36px
   play/pause button, with the same offset again as breathing room. Mirrored on
   the left so slide content stays centered on narrow panels. */
export const slideContentInset = (theme: Theme) => css`
  padding-right: calc(2 * ${theme.ds5.spacing.gap.large} + 36px);
  padding-left: calc(2 * ${theme.ds5.spacing.gap.large} + 36px);
`;
